import * as React from "react";
import { Card, CardContent, CardHeader } from "@material-ui/core";

export default () => (
  <Card>
    <CardHeader title="Welcome to the Eyeride Dashcam Control Dashboard" />
  </Card>
);
